import { LeisureType } from '@/domainLogic/index.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import type { ProductsData } from '@/app/api/search/products/createProductsData.ts';
import { URLParameters, ADULTS_DEFAULT } from '@/app/common/urlParameters.ts';
import { getTotalNumAdults, hasChildren } from '@/utils/peopleUtils.ts';

export enum TRAVELLER_TYPE {
  SOLO = 'solo',
  COUPLE = 'couple',
  GROUP = 'group',
  FAMILY = 'family',
}

export enum TRIP_STYLE {
  BEACH = 'beach',
  CITY = 'city',
}

export type SearchPersona = {
  travellerType: TRAVELLER_TYPE;
  tripStyle?: TRIP_STYLE;
};

export type SearchPersonaSource = {
  searchParams: SearchParams;
  productsData?: ProductsData;
};

const getTravellerType = (searchParams: SearchParams): TRAVELLER_TYPE => {
  if (hasChildren(searchParams[URLParameters.AGES])) return TRAVELLER_TYPE.FAMILY;

  const adults = getTotalNumAdults(String(searchParams[URLParameters.ADULTS] ?? ADULTS_DEFAULT));
  if (adults <= 1) return TRAVELLER_TYPE.SOLO;
  if (adults === 2) return TRAVELLER_TYPE.COUPLE;
  return TRAVELLER_TYPE.GROUP;
};

// memsearch's geo.leisure: the leisure type of the hotel's city, as a number.
const getTripStyle = (leisure?: number): TRIP_STYLE | undefined => {
  const leisureType = `L${leisure}`;
  if (leisureType === LeisureType.CITY_BREAKS) return TRIP_STYLE.CITY;
  if (leisureType === LeisureType.BEACH) return TRIP_STYLE.BEACH;
  return undefined;
};

export const getSearchPersona = ({ searchParams, productsData }: SearchPersonaSource): SearchPersona => ({
  travellerType: getTravellerType(searchParams),
  tripStyle: getTripStyle(productsData?.dealCards?.[0]?.product.geo.leisure),
});
